import React, { useState } from "react";
import * as S from "../shared/styles";

// ----------------------------  ExcludedSitesInput  ----------------------------
// Site codes a sampling run never imports. Type a code and press Enter (or a comma,
// or leave the box) to add it; several codes can be pasted at once, separated by
// commas or spaces. Codes are upper-cased and de-duplicated; click x to drop one.

export const parseSiteCodes = (text: string, current: string[]): string[] => {
  const out = [...current];
  text
    .split(/[\s,]+/)
    .map((s) => s.trim().toUpperCase())
    .filter(Boolean)
    .forEach((code) => {
      if (out.indexOf(code) === -1) out.push(code);
    });
  return out;
};

interface ExcludedSitesInputProps {
  value: string[];
  onChange: (sites: string[]) => void;
}

const chip: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  padding: "2px 8px",
  borderRadius: "12px",
  background: "#e5e7eb",
  fontSize: "13px",
};

const chipRemove: React.CSSProperties = {
  border: "none",
  background: "transparent",
  cursor: "pointer",
  padding: 0,
  color: "#6b7280",
  fontSize: "14px",
  lineHeight: 1,
};

const ExcludedSitesInput: React.FC<ExcludedSitesInputProps> = ({ value, onChange }) => {
  const [draft, setDraft] = useState("");

  const commit = () => {
    if (!draft.trim()) return;
    onChange(parseSiteCodes(draft, value));
    setDraft("");
  };

  return (
    <div>
      {value.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginBottom: "6px" }}>
          {value.map((site) => (
            <span key={site} style={chip}>
              {site}
              <button
                type="button"
                style={chipRemove}
                aria-label={`Remove ${site}`}
                onClick={() => onChange(value.filter((s) => s !== site))}
              >
                x
              </button>
            </span>
          ))}
        </div>
      )}
      <input
        style={{ ...S.formInput, width: "240px" }}
        value={draft}
        onChange={(e) => {
          const text = e.target.value;
          if (/[,\s]$/.test(text)) {
            onChange(parseSiteCodes(text, value));
            setDraft("");
          } else {
            setDraft(text);
          }
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            commit();
          }
        }}
        onBlur={commit}
        placeholder="e.g. DEMO1"
      />
    </div>
  );
};

export default ExcludedSitesInput;
